import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import PlanAwareLink from '../billing/PlanAwareLink';
import PlanTierLabel from '../billing/PlanTierLabel';
import { FEATURE } from '../../config/planFeatures';
import { useUserPlan } from '../../hooks/useUserPlan';
import Navbar from '../Items/Navbar';
import QuestionnairePage from './QuestionnairePage';
import PageMeta from '../seo/PageMeta';
import AuthContext from '../shared/AuthContext';
import LearningGuide from '../learning/LearningGuide';
import '../home/HomeDashboard.css';

const Home = () => {
    const { user } = useContext(AuthContext);
    const [loading, setIsLoading] = useState(false);
    const userProfile = user || JSON.parse(localStorage.getItem('userProfile') || 'null');
    const { canUseFeature } = useUserPlan();
    const leaderboardLocked = !canUseFeature(FEATURE.LEADERBOARD_RANK);

    return (
        <div className="library-page-shell qnaread-light-canvas">
            <PageMeta title="Library" description="Browse and study Q&A in the QnaRead library" />
            <Navbar userProfile={userProfile} loading={loading} />
            <div className="app-page-shell home-page-shell home-page-shell--minimal">
                <header className="home-minimal-hero">
                    <div>
                        <h1 className="home-minimal-title">Library</h1>
                        <p className="home-minimal-lead">
                            Questions come from your chosen modules and subscribed notebooks on{' '}
                            <Link to="/hub#learn-library">Learn</Link>, plus your own imports. Progress and
                            recommendations are on <Link to="/dashboard">Study hub</Link>.
                        </p>
                        <LearningGuide focus="library" />
                    </div>
                    <div className="home-minimal-actions">
                        <Link to="/dashboard" className="home-btn home-btn-secondary">Study hub</Link>
                        <Link to="/profile" className="home-btn home-btn-secondary">My progress</Link>
                        <PlanAwareLink to="/leaderboard" className="home-btn home-btn-secondary">
                            Leaderboard
                            {leaderboardLocked && <PlanTierLabel tier="Pro" />}
                        </PlanAwareLink>
                        <Link to="/hub" className="home-btn home-btn-secondary">Learn</Link>
                        <Link to="/review" className="home-btn home-btn-primary">Review</Link>
                    </div>
                </header>
                <QuestionnairePage setIsLoading={setIsLoading} />
            </div>
        </div>
    );
};

export default Home;
